import { render, staticRenderFns } from "./FloatingSteps.vue?vue&type=template&id=2b0e0f02&scoped=true&"
import script from "./FloatingSteps.vue?vue&type=script&lang=ts&"
export * from "./FloatingSteps.vue?vue&type=script&lang=ts&"
import style0 from "./FloatingSteps.vue?vue&type=style&index=0&id=2b0e0f02&scoped=true&lang=sass&"
import style1 from "./FloatingSteps.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0e0f02",
  null
  
)

export default component.exports